import { GroupedOpenQuestionAnswer } from '@core/candidate-types';

export interface DecoratedGroupedOpenQuestionAnswers {
  collapsed: string;
  question: GroupedOpenQuestionAnswer;
  decoratedStatus?: string | null;
}

export enum QuestionKind {
  Boolean = 'boolean',
  Dropdown = 'dropdown',
  File = 'file',
  Info = 'info',
  MultipleChoice = 'multi_choice',
  ScaleRating = 'scale_rating',
  Scorecard = 'scorecard',
  SingleChoice = 'single_choice',
  String = 'string',
  Text = 'text',
  Video = 'video',
  Legal = 'legal',

  Date = 'date',
  Number = 'number',
  Salary = 'salary',
}
